import { ReactElement, useEffect } from 'react';
import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { FilterPersonVM } from 'practice/view-models/practice-research';
import PmiTextField from 'shell/components/shared/text-field';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PracticeSearchType } from 'practice/pages/storage-practice';
import { DatePicker } from '@mui/lab';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<FilterPersonVM>();

  const filterTable = useFilterTable<PracticeSearchType>();

  useEffect(() => {
    filterTable.setValues(formContext.values);
  }, [formContext.values]);

  useEffect(() => {
    formContext.setValues(filterTable.values || {});
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          name="fiscalCode"
          id="fiscalCode"
          fullWidth
          value={formContext.values.fiscalCode?.toUpperCase() || ''}
          onChange={(event) => formContext.setFieldValue('fiscalCode', event.target.value)}
          inputProps={{
            maxLength: '16',
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          value={formContext.values.surname || ''}
          onChange={(event) => formContext.setFieldValue('surname', event.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurname-replica"
              checked={formContext.values.withoutSurname || false}
              onChange={() =>
                formContext.setFieldValue('withoutSurname', !formContext.values.withoutSurname)
              }
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          value={formContext.values.name || ''}
          onChange={(event) => formContext.setFieldValue('name', event.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutName-replica"
              checked={formContext.values.withoutName || false}
              onChange={() =>
                formContext.setFieldValue('withoutName', !formContext.values.withoutName)
              }
              inputProps={{ 'aria-label': 'Persona senza nome' }}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data nascita"
          aria-label="Data nascita"
          value={formContext.values?.birthDate || null}
          onChange={(date) => {
            formContext.setFieldValue('birthDate', date);
          }}
          renderInput={(params) => (
            <PmiTextField {...params} id="birthDate" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="outlined"
              color="cdmBrandThird"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Ripulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="cdmBrandThird" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research - Filter Practice - Form Filter component';

export default FormFilter;
